import { createAction } from '@reduxjs/toolkit';
import type { FetchableResource } from '~/_shared/types/fetchableResource/fetchableResource';
import type { GeoLocation } from '~/_shared/utils/geolocation/geolocation';
import type { PlaceId } from '~/places/places.types';
import type { PlacesSearchId } from '~/store/mapSettings/places/mapSettingsPlaces.state';
import type { PlacesSearchResult } from './places.state';

export const placesSearchesSetLoading = createAction(
  'FRONTEND_STATE_PLACES_PLACES_SEARCHES_SET_LOADING',
  (searchIds: ReadonlySet<PlacesSearchId>) => ({
    payload: { searchIds },
  })
);

export const placesSearchesRequestNextPage = createAction(
  'FRONTEND_STATE_PLACES_PLACES_SEARCHES_REQUEST_NEXT_PAGE_STATE',
  (searchIds: ReadonlySet<PlacesSearchId>) => ({
    payload: { searchIds },
  })
);

export const placesSearchesGetResultsSuccess = createAction(
  'FRONTEND_STATE_PLACES_SET_PLACES_SEARCH_RESULTS',
  (results: ReadonlyMap<PlacesSearchId, FetchableResource<PlacesSearchResult>>) => ({
    payload: { results },
  })
);

export const placesToolExpandSearch = createAction(
  'FRONTEND_STATE_PLACES_EXPAND_SEARCH',
  (id: PlaceId) => ({
    payload: { id },
  })
);

export const placesToolCollapseSearch = createAction(
  'FRONTEND_STATE_PLACES_COLLAPSE_SEARCH',
  (id: PlaceId) => ({
    payload: { id },
  })
);

export const placesToolSetStartingLocation = createAction(
  'FRONTEND_STATE_PLACES_SET_STARTING_LOCATION',
  (location: GeoLocation) => ({
    payload: { location },
  })
);

export const placesSearchHoverStart = createAction(
  'FRONTEND_STATE_PLACES_SET_HOVERED_SEARCH',
  ({ searchId }: { searchId: PlacesSearchId }) => ({
    payload: { searchId },
  })
);

export const placesSearchHoverStop = createAction(
  'FRONTEND_STATE_PLACES_STOP_HOVERED_SEARCH',
);

export const placeInListHoverStart = createAction(
  'FRONTEND_STATE_PLACES_SET_HOVERED_PLACE_IN_LIST',
  ({ placeId, placeSearchId }: { placeId: PlaceId; placeSearchId: PlacesSearchId }) => ({
    payload: { placeId, placeSearchId },
  })
);

export const placeInListHoverEnd = createAction(
  'FRONTEND_STATE_PLACES_STOP_HOVERED_PLACE_IN_LIST',
);
